import { render } from "./ChatSystem.vue?vue&type=template&id=46bdee87&scoped=true"
import script from "./ChatSystem.vue?vue&type=script&lang=js"
export * from "./ChatSystem.vue?vue&type=script&lang=js"

import "./ChatSystem.vue?vue&type=style&index=0&id=46bdee87&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46bdee87"]])

export default __exports__